/* unplugin-vue-components disabled */import script from "./SelectPrizeProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPrizeProductModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectPrizeProductModal.vue?vue&type=style&index=0&id=b5ae78d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ae78d2"]])

export default __exports__